export const cookiePrefix = 'mvt_';
export const participantSuffix = '_participant';
export const errorSuffix = '_error';

export const getTestCookieName = (testId: string) => `${cookiePrefix}${testId}`;
export const getParticipantCookieName = (testId: string) =>
  `${getTestCookieName(testId)}${participantSuffix}`;
export const getErrorCookieName = (testId: string) => `${getTestCookieName(testId)}${errorSuffix}`;
